import React from 'react';

import "./Background.scss";

export const Background = ()=><section className="Background"/>
